import { AccountStates } from '@generated/graphql';

export const CLOSED_ACCOUNT_STATES = [
  AccountStates.Canceled,
  AccountStates.Inactive,
  AccountStates.Failed,
];
